import { createContext, useContext, useMemo, useState } from "react"
const ContextsCategory = createContext()

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 */
export function ContextsCategoryProvider({ children }) {
	const [reload, setReload] = useState(true)
	const [openForm, setOpenForm] = useState(false)
	const [openInfo, setOpenInfo] = useState(false)
	const [openDelete, setOpenDelete] = useState(false)
	const [category, setCategory] = useState(null)

	const datos = useMemo(
		() => ({
			reload,
			refresh: () => setReload(!reload),
			openForm,
			setOpenForm,
			category,
			setCategory,
			openInfo,
			setOpenInfo,
			openDelete,
			setOpenDelete,
		}),
		[category, openDelete, openForm, openInfo, reload]
	)
	return <ContextsCategory.Provider value={datos}>{children}</ContextsCategory.Provider>
}

/**
 * @typedef {Object} QuestionContextParams
 * @property {boolean} reload
 * @property {function():void} refresh - actualiza el reload
 * @property {boolean} openForm
 * @property {function(boolean):void} setOpenForm
 * @property {Category|null} category
 * @property {function(Category|null):void} setCategory
 * @property {boolean} openInfo
 * @property {function(boolean):void} setOpenInfo
 * @property {boolean} openDelete
 * @property {function(boolean):void} setOpenDelete
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {QuestionContextParams}
 */

export function UseContextsCategory() {
	return useContext(ContextsCategory)
}
